module.exports = __webpack_public_path__ + "static/hexowatch-logo-5d037b787d1333898badedd5f90ab8bb.svg";